import { memo, useMemo } from "react";
import { Link, useLocation } from "react-router-dom";

const BlogCard = memo(function BlogCard({ id, title, image }) {
    return (
        <Link
            to={`/cow-long-us/${id}`}
            aria-label={`Read more about ${title}`}
            className="block"
        >
            <article className="relative rounded-xl overflow-hidden shadow-lg">
                <img
                    src={image}
                    alt={title}
                    loading="lazy"
                    decoding="async"
                    width="300"
                    height="320"
                    className="h-[320px] w-full object-cover"
                />

                <div className="absolute inset-0 bg-black/45 flex flex-col justify-end p-6">
                    <h3 className="text-white font-bold text-lg leading-snug mb-4">
                        {title}
                    </h3>
                    <span
                        className="text-white text-sm font-semibold border-b border-white w-fit focus:outline-none focus:ring-2 focus:ring-white"
                    >
                        READ MORE
                    </span>
                </div>
            </article>
        </Link>
    );
});

export default function RecommandSection({ posts = [] }) {
    const blogPosts = useMemo(() => {
        if (posts.length) return posts;

        return [
            {
                id: 1,
                title:
                    "Remote Work 2026: What’s Changing and How to Prepare in the USA",
                image:
                    "https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=800",
            },
            {
                id: 2,
                title:
                    "JobVine USA: Find the Right Job Quickly and Confidently",
                image:
                    "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=800",
            },
            {
                id: 3,
                title:
                    "Job Openings at Absolute Pets USA: Paid Time Off & Career Growth",
                image:
                    "https://images.unsplash.com/photo-1601758177266-bc599de87707?q=80&w=800",
            },
        ];
    }, [posts]);

    return (
        <section className="max-w-5xl mx-auto px-4">
            {/* AUTHOR */}
            <header className="mb-4">
                <p className="text-sm text-secondary">
                    Published by{" "}
                    <span className="text-blue-600 font-medium">
                        Danielle Andersen
                    </span>{" "}
                    on February 3, 2026
                </p>
            </header>

            {/* BLOG GRID */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {blogPosts.map((post) => (
                    <BlogCard key={post.id} {...post} />
                ))}
            </div>

            <hr className="my-8 border-orange" />

            {/* CTA SECTION */}
            <section
                aria-label="Promotional links"
                className="flex flex-col md:flex-row gap-4 mb-8"
            >
                <Link
                    to="/cow-long-us/0"
                    className="flex-1 border border-primary rounded-lg px-6 py-4 text-secondary flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-orange"
                >
                    <span>
                        Earn up to $1,500 weekly in a job in the USA and kickstart your career!
                    </span>
                    <span aria-hidden className="text-xl">←</span>
                </Link>

                <Link
                    to="/cow-long-us/0"
                    className="flex-1 bg-primary text-white rounded-lg px-6 py-4 flex items-center justify-between focus:outline-none focus:ring-2 focus:ring-orange"
                >
                    <span>
                        Job openings at Aspen Pharmacare USA: competitive salaries and growth opportunities.
                    </span>
                    <span aria-hidden className="text-xl">→</span>
                </Link>
            </section>
        </section>
    );
}

export const Legal = () => {
    const { pathname } = useLocation()
    const showRecommand =
        pathname === "/" || pathname.startsWith("/cow-long-us/");

    return (
        <>
            <div className="py-8">
                {showRecommand && <RecommandSection />}
                <section className="space-y-4 text-sm text-gray-700 leading-relaxed max-w-4xl mx-auto ">
                    <div>
                        <h4 className="font-semibold mb-2">Disclaimer</h4>
                        <p>
                            We never charge fees for job applications or access to job listings. Any request for payment related to a job opportunity should be treated as fraudulent.
                        </p>
                    </div>
                    <div>
                        <h4 className="font-semibold mb-2">Advertiser Disclosure</h4>
                        <p>
                            This site is supported by advertising. Some job listings or links may be from partners who compensate us, which may affect how opportunities appear.
                        </p>
                    </div>
                    <div>
                        <h4 className="font-semibold mb-2">Editorial Note</h4>
                        <p>
                            Job information is provided for general guidance only. Details such as availability, requirements, and benefits may change and should be verified with the employer.
                        </p>
                    </div>
                </section>
            </div>
        </>
    )
}